export default "__VITE_ASSET__Rr93yh2Y__"